"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downexInstructions = exports.defaultInstructions = exports.readyToPlay = exports.reverseOrderInstructions = exports.reverseOrderPrompt = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const taskSetup_1 = require("../../taskSetup");
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const taskStore_1 = require("../../../taskStore");
let setPromptDurations = false;
const instructionData = [
    // downex instructions
    {
        prompt: 'memoryGameInstruct1',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct6Downex',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct10Downex',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'heartsAndFlowersEncourage2',
        image: 'rocket@2x',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'heartsAndFlowersPlayTime',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    // older kid instructions
    {
        prompt: 'memoryGameInstruct1',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct2',
        image: 'highlightedBlock',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct3',
        video: 'selectSequence',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct4',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct5',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameInstruct6',
        image: 'catAvatar',
        buttonText: 'continueButtonText',
    },
    {
        prompt: 'memoryGameBackwardPrompt',
        video: 'selectSequenceReverse',
        buttonText: 'continueButtonText',
    },
];
const replayButtonHtmlId = 'replay-btn-revisited';
const instructions = instructionData.map((data) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            const mediaSrc = data.video ? __1.mediaAssets.video[data.video] : __1.mediaAssets.images[data.image];
            return `<div class="lev-stimulus-container">
                        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                        <div class="lev-row-container instruction">
                            <p>${t[data.prompt]}</p>
                        </div>
                        <div class="lev-stim-content-x-3">
                          ${data.video
                ? `
                              <video class='instruction-video-small' autoplay loop>
                                <source src=${__1.mediaAssets.video[data.video]} type='video/mp4'>
                              </video>
                            `
                : (0, taskStore_1.taskStore)().story || data.image !== 'catAvatar'
                    ? `
                                <img
                                  src=${__1.mediaAssets.images[data.image]}
                                  alt="Image not loading ${mediaSrc}. Please continue the task."
                                />
                              `
                    : ''}
                        </div>                    
                    </div>`;
        },
        prompt_above_buttons: true,
        button_choices: data.buttonText ? ['Next'] : [],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            if (data.buttonText) {
                return [
                    `<button class="primary">
                  ${t[data.buttonText]}
          </button>`,
                ];
            }
        },
        keyboard_choices: 'NO_KEYS',
        post_trial_gap: 500,
        on_load: async () => {
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
                onEnded: () => {
                    if (!data.buttonText) {
                        taskSetup_1.jsPsych.finishTrial();
                    }
                },
            };
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[data.prompt], audioConfig);
            const pageStateHandler = new helpers_1.PageStateHandler(data.prompt, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            // hide toast if it is there
            const toast = document.getElementById('lev-toast-default');
            if (toast) {
                toast.classList.remove('show');
            }
            // set the display prompt durations here, since awaiting promise during a display trial is not possible in the jsPsych plugin
            if (!setPromptDurations) {
                setPromptDurations = true;
                const displayPromptDurations = (0, helpers_1.isEnglish)((0, taskStore_1.taskStore)().language)
                    ? {
                        memoryGameInstruct7Downex: await helpers_1.PageAudioHandler.getAudioDuration(__1.mediaAssets.audio.memoryGameInstruct7Downex),
                        memoryGameDisplay: await helpers_1.PageAudioHandler.getAudioDuration(__1.mediaAssets.audio.memoryGameDisplay),
                        memoryGameInstruct2Downex: await helpers_1.PageAudioHandler.getAudioDuration(__1.mediaAssets.audio.memoryGameInstruct2Downex),
                        memoryGameInstruct4Downex: await helpers_1.PageAudioHandler.getAudioDuration(__1.mediaAssets.audio.memoryGameInstruct4Downex),
                    }
                    : {
                        memoryGameDisplay: await helpers_1.PageAudioHandler.getAudioDuration(__1.mediaAssets.audio.memoryGameDisplay),
                    };
                (0, taskStore_1.taskStore)('displayPromptDurations', displayPromptDurations);
            }
        },
        on_finish: () => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
        },
    };
});
exports.reverseOrderPrompt = instructions.pop();
exports.reverseOrderInstructions = instructions.pop();
exports.readyToPlay = instructions.pop();
exports.defaultInstructions = instructions.slice(5, 9);
exports.downexInstructions = instructions.slice(0, 5);
